import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const savedLanguage = typeof window !== 'undefined' ? (localStorage.getItem('appLanguage') || (navigator.language || 'en').startsWith('fr') ? 'fr' : 'en') : 'en';

const resources = {
  en: {
    translation: {
      'Settings': 'Settings',
      'Edit Profile': 'Edit Profile',
      'Account Management': 'Account Management',
      'Change Password': 'Change Password',
      'Manage Subscriptions': 'Manage Subscriptions',
      'Linked Accounts': 'Linked Accounts',
      'Notifications': 'Notifications',
      'Weather Alerts': 'Weather Alerts',
      'Crop Health Updates': 'Crop Health Updates',
      'System Notifications': 'System Notifications',
      'App Preferences': 'App Preferences',
      'Units': 'Units',
      'Language': 'Language',
      'Dark Mode': 'Dark Mode',
      'Help & Support': 'Help & Support',
      'Privacy Policy': 'Privacy Policy',
      'Terms of Service': 'Terms of Service',
      'Logout': 'Logout',
      'Loading...': 'Loading...',
      'Last Name': 'Last Name',
      'First Name': 'First Name',
      'Email': 'Email',
      'Phone': 'Phone',
      'Cancel': 'Cancel',
      'Save Changes': 'Save Changes',
      'Old Password': 'Old Password',
      'New Password': 'New Password',
      'Confirm Password': 'Confirm Password',
      'Change Password Button': 'Change Password',
      'Manage Subscription': 'Manage Subscription',
      'Current Plan: Free': 'Current Plan: Free',
      'All features are included at no cost.': 'All features are included at no cost.',
      'Free forever': 'Free forever',
      'Available Plans': 'Available Plans',
      'All features are free. No subscription or payment is required.': 'All features are free. No subscription or payment is required.',
      'English': 'English',
      'French': 'French'
    }
  },
  fr: {
    translation: {
      'Settings': 'Paramètres',
      'Edit Profile': 'Modifier le profil',
      'Account Management': 'Gestion du compte',
      'Change Password': 'Changer le mot de passe',
      'Manage Subscriptions': 'Gérer les abonnements',
      'Linked Accounts': 'Comptes liés',
      'Notifications': 'Notifications',
      'Weather Alerts': 'Alertes météo',
      'Crop Health Updates': 'Mises à jour de la santé des cultures',
      'System Notifications': 'Notifications du système',
      'App Preferences': "Préférences de l'application",
      'Units': 'Unités',
      'Language': 'Langue',
      'Dark Mode': 'Mode sombre',
      'Help & Support': 'Aide et support',
      'Privacy Policy': 'Politique de confidentialité',
      'Terms of Service': "Conditions d'utilisation",
      'Logout': 'Déconnexion',
      'Loading...': 'Chargement...',
      'Last Name': 'Nom',
      'First Name': 'Prénom',
      'Email': 'Email',
      'Phone': 'Téléphone',
      'Cancel': 'Annuler',
      'Save Changes': 'Enregistrer',
      'Old Password': 'Ancien mot de passe',
      'New Password': 'Nouveau mot de passe',
      'Confirm Password': 'Confirmer le mot de passe',
      'Change Password Button': 'Changer le mot de passe',
      'Manage Subscription': 'Gérer l’abonnement',
      'Current Plan: Free': 'Forfait actuel : Gratuit',
      'All features are included at no cost.': 'Toutes les fonctionnalités sont incluses gratuitement.',
      'Free forever': 'Gratuit pour toujours',
      'Available Plans': 'Forfaits disponibles',
      'All features are free. No subscription or payment is required.': 'Toutes les fonctionnalités sont gratuites. Aucun abonnement ni paiement requis.',
      'English': 'Anglais',
      'French': 'Français'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
